module.exports = __webpack_public_path__ + "static/media/patient-icon.2ce53e6d.svg";